module.exports = __webpack_public_path__ + "static/img/bs-chjt+logo.d4b46f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ch/bs-chjt+logo.png
// module id = YJGb
// module chunks = 1